// /opt/isp_erp/frontend/src/pages/warehouse/RMA.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  IconButton,
  Tooltip,
  Alert,
  CircularProgress,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,  // ✅ Agregar esta importación
  Switch        
} from '@mui/material';
import {
  Build,
  Delete,
  Visibility,
  Description,
  Refresh,
  CheckCircle,
  Close,
  AssignmentReturn
} from '@mui/icons-material';
import { warehouseAPI } from '../../api/warehouse.api';

const RMA = () => {
  const [equiposRMA, setEquiposRMA] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEquipo, setSelectedEquipo] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [reingresoOpen, setReingresoOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [reingresoData, setReingresoData] = useState({
    observaciones: '',
    reparado: true
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    cargarEquiposRMA();
  }, []);

  const cargarEquiposRMA = async () => {
    setLoading(true);
    try {
      // Por ahora usamos listarEquipos y filtramos
      const response = await warehouseAPI.listarEquipos();
      const rmaEquipos = (response.data || []).filter(e => e.estado_actual === 'RMA_BAJA');
      setEquiposRMA(rmaEquipos);
    } catch (error) {
      console.error('Error cargando equipos RMA:', error);
    } finally {
      setLoading(false);
    }
  };

  const verDetalle = (equipo) => {
    setSelectedEquipo(equipo);
    setDetailOpen(true);
  };

  const abrirReingreso = (equipo) => {
    setSelectedEquipo(equipo);
    setReingresoData({
      observaciones: '',
      reparado: true
    });
    setReingresoOpen(true);
  };


  const registrarReingreso = async () => {
    setSubmitting(true);
    try {
      // ✅ CAMBIAR: Usar el nuevo endpoint de reingreso
      await warehouseAPI.reingresarEquipoRMA(
        selectedEquipo.sn,
        `REINGRESO: ${reingresoData.observaciones}`
      );

      setSuccess(true);
      setReingresoOpen(false);
      cargarEquiposRMA();

      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      setError(error.response?.data?.detail || 'Error al registrar reingreso');
      setTimeout(() => setError(''), 5000);
    } finally {
      setSubmitting(false);
    }
  };


  const getTipoFalla = (diagnostico) => {
    if (!diagnostico) return 'No especificado';
    if (diagnostico.toLowerCase().includes('físico')) return 'Daño Físico';
    if (diagnostico.toLowerCase().includes('electrónico')) return 'Falla Electrónica';
    if (diagnostico.toLowerCase().includes('firmware')) return 'Falla Firmware';
    if (diagnostico.toLowerCase().includes('conexión')) return 'Falla Conexión';
    return 'Falla Técnica';
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const filteredEquipos = equiposRMA.filter(e => {
    if (tabValue === 0) return true; // Todos
    if (tabValue === 1) return e.diagnostico_rma && e.diagnostico_rma.toLowerCase().includes('físico');
    if (tabValue === 2) return e.diagnostico_rma && e.diagnostico_rma.toLowerCase().includes('electrónico');
    if (tabValue === 3) return e.diagnostico_rma && !e.diagnostico_rma.toLowerCase().includes('físico') && !e.diagnostico_rma.toLowerCase().includes('electrónico');
    return true;
  });

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          RMA / Bajas Técnicas
        </Typography>
        <Button
          variant="outlined"
          onClick={cargarEquiposRMA}
          startIcon={<Refresh />}
          disabled={loading}
        >
          Actualizar
        </Button>
      </Box>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#ffebee' }}>
                <Typography variant="h4" color="error">
                  {equiposRMA.length}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Equipos en RMA
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#fff3e0' }}>
                <Typography variant="h4" color="warning.main">
                  {equiposRMA.filter(e => e.diagnostico_rma?.toLowerCase().includes('físico')).length}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Daño Físico
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#e8eaf6' }}>
                <Typography variant="h4" color="info.main">
                  {equiposRMA.filter(e => e.diagnostico_rma?.toLowerCase().includes('electrónico')).length}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Falla Electrónica
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#e8f5e9' }}>
                <Typography variant="h4" color="success.main">
                  {equiposRMA.filter(e => e.fecha_rma).length}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  En Proceso
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ mb: 2 }}>
            <Tab label="Todos" />
            <Tab label="Daño Físico" />
            <Tab label="Falla Electrónica" />
            <Tab label="Otros" />
          </Tabs>

          <TableContainer component={Paper} variant="outlined">
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell>SN</TableCell>
                  <TableCell>Modelo</TableCell>
                  <TableCell>Tipo de Falla</TableCell>
                  <TableCell>Fecha RMA</TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
                      <CircularProgress size={40} />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Cargando equipos en RMA...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredEquipos.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
                      <CheckCircle sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
                      <Typography variant="body1" color="success.main">
                        No hay equipos en RMA
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Todos los equipos están operativos o en buen estado
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredEquipos.map((equipo) => (
                    <TableRow key={equipo.id} hover>
                      <TableCell>
                        <strong>{equipo.sn}</strong>
                      </TableCell>
                      <TableCell>{equipo.modelo}</TableCell>
                      <TableCell>
                        <Chip
                          label={getTipoFalla(equipo.diagnostico_rma)}
                          size="small"
                          color={equipo.diagnostico_rma?.toLowerCase().includes('físico') ? 'error' : 'warning'}
                          icon={<Build />}
                        />
                      </TableCell>
                      <TableCell>{formatDate(equipo.fecha_rma)}</TableCell>
                      <TableCell>
                        <Chip
                          label={equipo.fecha_rma ? "En Proceso" : "Pendiente"}
                          color={equipo.fecha_rma ? "info" : "default"}
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Ver detalle">
                          <IconButton size="small" onClick={() => verDetalle(equipo)}>
                            <Visibility />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Reingresar a inventario">
                          <IconButton size="small" color="success" onClick={() => abrirReingreso(equipo)}>
                            <AssignmentReturn />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Dialog de Detalle */}
      <Dialog open={detailOpen} onClose={() => setDetailOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Detalle de RMA - {selectedEquipo?.sn}
        </DialogTitle>
        <DialogContent>
          {selectedEquipo && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary">Modelo:</Typography>
                  <Typography variant="body1">{selectedEquipo.modelo}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary">Diagnóstico:</Typography>
                  <Paper sx={{ p: 2, bgcolor: '#f5f5f5', mt: 0.5 }}>
                    <Typography variant="body2">
                      {selectedEquipo.diagnostico_rma || 'No especificado'}
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary">Fecha de ingreso a RMA:</Typography>
                  <Typography variant="body1">{formatDate(selectedEquipo.fecha_rma)}</Typography>
                </Grid>
                {selectedEquipo.observaciones && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">Observaciones adicionales:</Typography>
                    <Typography variant="body2">{selectedEquipo.observaciones}</Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailOpen(false)}>Cerrar</Button>
          <Button 
            variant="contained" 
            color="success"
            onClick={() => {
              setDetailOpen(false);
              abrirReingreso(selectedEquipo);
            }}
          >
            Reingresar a Inventario
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Reingreso */}
      <Dialog open={reingresoOpen} onClose={() => !submitting && setReingresoOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Reingreso a Inventario
          {selectedEquipo && (
            <Typography variant="body2" color="text.secondary">
              SN: {selectedEquipo.sn} - {selectedEquipo.modelo}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={reingresoData.reparado}
                  onChange={(e) => setReingresoData({ ...reingresoData, reparado: e.target.checked })}
                />
              }
              label="¿El equipo fue reparado correctamente?"
            />
            
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Observaciones del reingreso"
              value={reingresoData.observaciones}
              onChange={(e) => setReingresoData({ ...reingresoData, observaciones: e.target.value })}
              placeholder="Indique las reparaciones realizadas, pruebas realizadas, etc."
              sx={{ mt: 2 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReingresoOpen(false)} disabled={submitting}>
            Cancelar
          </Button>
          <Button 
            onClick={registrarReingreso} 
            variant="contained" 
            color="success"
            disabled={submitting}
          >
            {submitting ? <CircularProgress size={24} /> : 'Reingresar a Inventario'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar de éxito */}
      {success && (
        <Alert 
          severity="success" 
          sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999 }}
          onClose={() => setSuccess(false)}
        >
          Equipo reingresado a inventario exitosamente
        </Alert>
      )}

      {/* Snackbar de error */}
      {error && (
        <Alert 
          severity="error" 
          sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999 }}
          onClose={() => setError('')}
        >
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default RMA;
